import React, { useContext, createContext, useState, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { localStorageHelper } from '../../../../utils/localStorageHelper'

const STORAGE_KEY = 'denali-ai-nav-collapsed'

const DenaliAiLayoutContext = createContext({
  sideNavCollapsed: false
})

export const useLayoutContext = () => {
  return useContext(DenaliAiLayoutContext)
}

function LayoutProvider ({ children }) {
  // Initialize from localStorage, default to true (collapsed)
  const [navCollapsed, setNavCollapsedState] = useState(() => {
    const saved = localStorageHelper.tryLoad(STORAGE_KEY)
    return saved !== null ? saved : true
  })

  // Set nav state and persist to localStorage
  const setNavCollapsed = useCallback((value) => {
    const newValue = typeof value === 'function' ? value(navCollapsed) : value
    setNavCollapsedState(newValue)
    localStorageHelper.tryStore(STORAGE_KEY, newValue)
  }, [navCollapsed])

  // Set nav state WITHOUT persisting (for temporary changes)
  const setNavCollapsedTemporary = useCallback((value) => {
    const newValue = typeof value === 'function' ? value(navCollapsed) : value
    setNavCollapsedState(newValue)
  }, [navCollapsed])

  const toggleNav = useCallback(() => {
    setNavCollapsed(s => !s)
  }, [setNavCollapsed])

  const contextValue = useMemo(() => {
    return {
      navCollapsed,
      setNavCollapsed,
      setNavCollapsedTemporary,
      toggleNav
    }
  }, [navCollapsed, setNavCollapsed, setNavCollapsedTemporary, toggleNav])

  return (
    <DenaliAiLayoutContext.Provider value={contextValue}>
      {children}
    </DenaliAiLayoutContext.Provider>
  )
}

LayoutProvider.propTypes = {
  children: PropTypes.node
}

export default LayoutProvider
